/* Product-card colour dots: hover or tap a dot to show that colour on the card (snippets/ml-card-swatches.liquid). */
(function () {
  if (window.mlSwatchesReady) return;
  window.mlSwatchesReady = true;

  function cardOf(dot) {
    return dot.closest('.ml-prod, .card-wrapper, .grid__item');
  }

  function show(dot, commit) {
    var card = cardOf(dot);
    if (!card || !dot.dataset.src) return;
    var img = card.querySelector('.ml-prod__img:not(.ml-prod__img--alt), .card__media img');
    if (img) {
      if (!img.dataset.mlOrigSrc) {
        img.dataset.mlOrigSrc = img.getAttribute('src') || '';
        img.dataset.mlOrigSrcset = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', dot.dataset.srcset);
      img.setAttribute('src', dot.dataset.src);
    }
    card.classList.add('ml-swatch-preview');
    if (commit) {
      card.querySelectorAll('[data-ml-swatches] .ml-swatch').forEach(function (d) {
        d.classList.toggle('is-active', d === dot);
      });
      card.querySelectorAll('a[href*="/products/"]:not(.ml-swatch)').forEach(function (a) {
        a.setAttribute('href', dot.getAttribute('href'));
      });
      card.dataset.mlCommitted = '1';
    }
  }

  function restore(card) {
    var active = card.querySelector('[data-ml-swatches] .ml-swatch.is-active');
    if (active) show(active, false);
  }

  document.addEventListener('mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('[data-ml-swatches] .ml-swatch');
    if (dot && matchMedia('(hover: hover)').matches) show(dot, false);
  });
  document.addEventListener('mouseout', function (e) {
    var group = e.target.closest && e.target.closest('[data-ml-swatches]');
    if (group && !group.contains(e.relatedTarget)) {
      var card = cardOf(group);
      if (card) restore(card);
    }
  });
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-ml-swatches] .ml-swatch');
    if (!dot || !dot.dataset.src) return;
    e.preventDefault();
    show(dot, true);
  });
})();
